import React, { useState } from 'react';
import firebase from '../../store/firebase';
import Papa from 'papaparse'; // For CSV parsing
import axios from 'axios'
import { FB_URL } from '../../store/actions/types'

const UpdateCompanyNames = () => {
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState('');
  const [error, setError] = useState(null);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
    setStatus('');
    setError(null);
  };

  const updateCompanyNamesFromCSV = async () => {
    if (!file) {
      setError('Please select a CSV file');
      return;
    }

    setStatus('Processing...');

    try {
      Papa.parse(file, {
        complete: async (result) => {
          const updates = {};
          const errors = [];
          let rowIndex = 1; // Track row number for data rows (excluding header)

          // Iterate through parsed data rows
          for (const row of result.data) {
            const { email, company } = row; // Access columns by header names

            // Validate row data
            if (!email || !company) {
              errors.push(`Invalid data at row ${rowIndex}: [${email || ''},${company || ''}]`);
              rowIndex++;
              continue;
            }

            try {
              // Find user by email in Firebase
              const userSnapshot = await firebase
                .database
                .ref('user')
                .orderByChild('email')
                .equalTo(email.trim())
                .once('value');

              const usersSnapshot = await firebase
                .database
                .ref('users')
                .orderByChild('email')
                .equalTo(email.trim())
                .once('value');

              let uid, userID;
              userSnapshot.forEach((child) => {
                uid = child.key;
              });

              usersSnapshot.forEach((child) => {
                userID = child.key;
              });

              if (!uid || !userID) {
                errors.push(`User not found for email at row ${rowIndex}: ${email}`);
                rowIndex++;
                continue;
              }

              // Prepare updates
              updates[`/users/${userID}/companyName`] = company.trim();
              updates[`/user/${uid}/companyName`] = company.trim();

            } catch (err) {
              errors.push(`Error processing email at row ${rowIndex}: ${email} - ${err.message}`);
            }
            rowIndex++;
          }

          // Perform batch update
          try {
            if (Object.keys(updates).length > 0) {
                 var ress = await axios.post(`${FB_URL}/m115-freshcard`, {
                    params: {
                         updates: updates, //user wallet address                       
                     }
                   })
 
               if (ress.data || ress.data.success === true) {
                 console.log('Successfully imported csv');               }
               else {
                 console.error('Error updating importing csv:', error);
               };             
              // console.log('fixcompany 3 : ');
              // await firebase.database.ref().update(updates);
              //  console.log('fixcompany 4 : ', updates);
              setStatus(`Successfully updated ${Object.keys(updates).length / 2} records`);
            } else {
              setStatus('No valid updates to process');
            }

            if (errors.length > 0) {
              setError(`Completed with ${errors.length} errors:\n${errors.join('\n')}`);
            }
          } catch (err) {
            setError(`Failed to update Firebase: ${err.message}`);
            setStatus('');
          }
        },
        error: (parseError) => {
          setError(`Error parsing CSV: ${parseError.message}`);
          setStatus('');
        },
        header: true, // Treat first row as headers
        skipEmptyLines: true, // Skip empty lines
        delimiter: ',', // Ensure comma delimiter
      });
    } catch (err) {
      setError(`Unexpected error: ${err.message}`);
      setStatus('');
    }
  };

  return (
    <div>
      <h2>Update Company Names</h2>
      <input
        type="file"
        accept=".csv"
        onChange={handleFileChange}
      />
      <button
        onClick={updateCompanyNamesFromCSV}
        disabled={!file}
      >
        Update Company Names
      </button>
      {status && <p>{status}</p>}
      {error && <pre style={{ color: 'red' }}>{error}</pre>}
    </div>
  );
};

export default UpdateCompanyNames;